export default {
  files: [],
  file: null,
  auth_user_files: [],
  pagination: {
    total: 1,
    current_page: 1,
  },
}
